class NotificationsService {
  constructor(apiService) {
    this.api = apiService
  }

  async getNotifications(limit = 20) {
    return await this.api.get(`${this.api.pharmacy}/notifications?limit=${limit}`)
  }

  async getUnseenNotifications(limit = 20) {
    return await this.api.get(`${this.api.pharmacy}/notifications/unseen?limit=${limit}`)
  }

  async markSeen(notificationKey) {
    return await this.api.post(`${this.api.pharmacy}/notifications/seen`, {
      notification_key: notificationKey,
    })
  }
}

export default NotificationsService
